export interface IPermissionModel{
  codename: string,
  name: string,
}

export class PermissionModel implements IPermissionModel{
  codename: string;
  name: string;

  constructor(data: IPermissionModel) {
    this.codename = data.codename;
    this.name = data.name;
  }
}